import React, { useState } from 'react';
import Button from '../elements/button/Button';
import { Modal } from '../elements/modal/Modal';

interface HelpEntry {
  term: string;
  text: string;
  steps?: string[];
}

const HELP_TEXT: HelpEntry[] = [
  {
    term: 'Add',
    text: 'NEW button (top left) opens the "Add new" dialog; enter a title and URL.',
  },
  { term: 'Edit / remove', text: 'Each bookmark has EDIT and REMOVE buttons.' },
  { term: 'Search', text: 'Search box filters bookmarks by title or URL.' },
  {
    term: 'Import / export',
    text: 'IMPORT/EXPORT buttons (top right) load/save all bookmarks as a .pb file. On mobile they live under the "..." menu.',
  },
  {
    term: 'Cloud',
    text: 'CLOUD button (top right) syncs bookmarks with your connected cloud storage (Dropbox).',
  },
  {
    term: 'Share target (Android)',
    text: 'Install the app to your home screen (Chrome menu → "Add to Home screen"), then share any page to "Progressive bookmarks" from the share sheet — a pre-filled "Add new" dialog opens.',
  },
  {
    term: 'Share target (iOS via Shortcut)',
    text: 'iOS Safari does not support share targets, but a Shortcut reuses the same flow. Create it once, then in Safari tap Share → your shortcut: the app opens with a pre-filled "Add new" dialog. Steps:',
    steps: [
      'Open the Shortcuts app and tap + to create a new shortcut.',
      'Tap "Add Action", search for "Receive" and add "Receive URLs from Share Sheet".',
      'Tap the ⓘ (info) icon at the bottom of the shortcut, enable "Show in Share Sheet" (receiving type: URLs), and tap Done.',
      'Add a "Text" action: type https://<your-app-domain>/?url= and then insert the "Shortcut Input" magic variable (pick it from the suggestions bar above the keyboard).',
      'Add an "Open URLs" action after the Text action (it takes the text you just built as its input).',
      'Name the shortcut, e.g. "Save bookmark", and tap Done.',
      'In Safari, share any page and tap "Save bookmark" in the share sheet.',
    ],
  },
];

export const Help: React.FC<{ className?: string }> = ({ className }) => {
  const [show, setShow] = useState(false);
  const close = () => setShow(false);

  return (
    <div className={className}>
      <Button
        small
        icon="help_outline"
        aria-label="Help"
        onClick={() => setShow(true)}
      >
        <span>HELP</span>
      </Button>
      <Modal show={show} header="Help" onOk={close} onCancel={close}>
        <div className="content">
          <ul>
            {HELP_TEXT.map(({ term, text, steps }) => (
              <li key={term} className="mb-3">
                <strong>{term}</strong> — {text}
                {steps && (
                  <ol>
                    {steps.map((step, i) => (
                      <li key={i}>{step}</li>
                    ))}
                  </ol>
                )}
              </li>
            ))}
          </ul>
        </div>
      </Modal>
    </div>
  );
};

export default Help;
